(function ($) {

    $('footer .menu-title-wrap').on('click', function () {
        $(this).find('img').toggleClass('active');
        $(this).next().slideToggle();
    });

    // $('.tablepress').each(function (index) {
    //     new SimpleBar($('.tablepress')[index]);
    // });

    $(document).on('click', '.moove-gdpr-infobar-allow-all, .moove-gdpr-modal-allow-all, .moove-gdpr-modal-save-settings', function () {
        setTimeout(function () {
            $('.cookiewall').removeClass('visible');
        }, 300);
    });

    $(window).on('load', function () {
        if ($('.privacy-policy').length == 0) {
            setTimeout(function () {
                $('#moove_gdpr_cookie_info_bar').addClass('visible');
                $('.cookiewall').addClass('visible');
            }, 50);
        }
    });
})(jQuery);